/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, Typography, IconButton, Tooltip } from '@material-ui/core';
import useCompany from '../../hooks/useCompany';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getArchives } from '../../graphql/query';
import {
  createArchive,
  deleteArchive,
  updateArchive,
} from '../../graphql/mutation';

import { errorAlert, errorDeleteAlert, getRowId } from '../common/funcs';
import PageLayout from '../shared/PageLayout';
import { TableComponent } from '../components/TableComponent';
import { createdAtFormatter } from '../common/formater';
import { Command } from '../components/Command';
import SearchTable from '../components/SearchTable';
import PopupEditing from '../components/PopupEditing';
import AlertLocal from '../components/AlertLocal';
import PopupArchive from './PopupArchive';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

export default function ArchiveManagement({
  isRTL,
  words,
  theme,
  menuitem,
}: any) {
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();

  const columns = [
    { name: 'createdAt', title: isRTL ? 'التاريخ' : 'Date' },
    {
      name: isRTL ? 'titleAr' : 'title',
      title: isRTL ? 'اسم المستند' : 'Document Name',
    },
    { name: 'desc', title: isRTL ? 'الوصف' : 'Description' },
    { name: 'filename', title: isRTL ? 'الملف' : 'File' },
  ];

  const [tableColumnExtensions]: any = useState([
    { columnName: 'createdAt', width: 150 },
    { columnName: isRTL ? 'titleAr' : 'title', width: 250 },
    { columnName: 'desc', width: 300 },
    { columnName: 'filename', width: 150 },
  ]);

  const [loadArchives, archivesData]: any = useLazyQuery(getArchives, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [{ query: getArchives }],
  };

  const [addArchive] = useMutation(createArchive, refresQuery);
  const [editArchive] = useMutation(updateArchive, refresQuery);
  const [removeArchive] = useMutation(deleteArchive, refresQuery);

  useEffect(() => {
    loadArchives();
  }, []);

  useEffect(() => {
    if (archivesData?.loading) {
      setLoading(true);
    }
    if (archivesData?.data?.getArchives?.data) {
      const data = archivesData?.data?.getArchives?.data;
      setRows(data);
      setLoading(false);
    }
  }, [archivesData]);

  const commitChanges = async ({ deleted }: any) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeArchive({ variables: { _id } });
      if (res?.data?.deleteArchive?.ok === false) {
        if (res?.data?.deleteArchive?.error?.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      }
    }
  };

  const refresh = () => {
    loadArchives();
  };

  const fileFormatter = ({ row }: any) => {
    if (!row.url) return <span>-</span>;
    return (
      <Tooltip title={isRTL ? 'فتح PDF' : 'Open PDF'}>
        <IconButton
          size="small"
          onClick={() => window.open(row.url, '_blank', 'noopener,noreferrer')}
          color="primary"
        >
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      loading={loading}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            margin: '10px 25px',
          }}
        >
          <Typography
            style={{
              fontWeight: 'bold',
              fontSize: 20,
            }}
          >
            {isRTL ? 'مستندات الشركة' : 'Company Documents'}
          </Typography>
        </Box>

        <Paper
          elevation={5}
          style={{
            margin: 25,
            marginTop: 10,
            overflow: 'auto',
            width: width - 300,
            borderRadius: 10,
          }}
        >
          <Grid rows={rows} columns={columns} getRowId={getRowId}>
            <SortingState />
            <EditingState onCommitChanges={commitChanges} />
            <SearchState />
            <PagingState defaultCurrentPage={0} defaultPageSize={10} />

            <IntegratedSorting />
            <IntegratedFiltering />
            <IntegratedPaging />

            <DragDropProvider />

            <Table
              messages={{
                noData: isRTL ? 'لا يوجد بيانات' : 'No data',
              }}
              tableComponent={TableComponent}
              rowComponent={(props: any) => (
                <Table.Row {...props} style={{ height: 50 }}></Table.Row>
              )}
              columnExtensions={tableColumnExtensions}
            />

            <TableColumnReordering
              defaultOrder={[
                'createdAt',
                isRTL ? 'titleAr' : 'title',
                'desc',
                'filename',
              ]}
            />
            <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
            <TableHeaderRow
              showSortingControls
              titleComponent={({ children }) => {
                return (
                  <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                    {children}
                  </Typography>
                );
              }}
            />

            <DataTypeProvider
              for={['createdAt']}
              formatterComponent={createdAtFormatter}
            />
            <DataTypeProvider
              for={['filename']}
              formatterComponent={fileFormatter}
            />

            <TableEditColumn
              showAddCommand
              showEditCommand
              showDeleteCommand
              commandComponent={Command}
            ></TableEditColumn>

            <Toolbar />
            <PagingPanel
              pageSizes={[5, 10, 20, 50, 0]}
              messages={{
                info: isRTL
                  ? ({
                      from,
                      to,
                      count,
                    }: {
                      from: number;
                      to: number;
                      count: number;
                    }) => ` من ${from} الى ${to} المجموع ${count}`
                  : undefined,
                rowsPerPage: isRTL ? 'عدد السطور' : undefined,
              }}
            />
            <SearchPanel
              inputComponent={(props: any) => {
                return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
              }}
            />

            <PopupEditing
              theme={theme}
              addAction={addArchive}
              editAction={editArchive}
              alrt={alrt}
              setAlrt={setAlrt}
            >
              <PopupArchive
                isRTL={isRTL}
                words={words}
                theme={theme}
                company={company}
              ></PopupArchive>
            </PopupEditing>
          </Grid>
        </Paper>
        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top
          ></AlertLocal>
        )}
      </Box>
    </PageLayout>
  );
}
